import { eases } from "../../motion/eases";
export var SIZE_TRANSITION = {
  duration: 0.25,
  ease: eases.primary
};